import { createReducer, Action, on } from '@ngrx/store';

import * as SoilTypeActions from './soil-type.actions';
import { SoilTypeState } from '../models/soil-type.models';

const reducer = createReducer<SoilTypeState>(
  {},
  on(SoilTypeActions.setSoilTypes, (state, { soilTypes }) => ({ ...state, soilTypes })),
);

export const soilTypeReducer = (state: SoilTypeState | undefined, action: Action) =>
  reducer(state, action);
